export default "__VITE_ASSET__Bxl0By5B__"